export default function makeExternalUrl(url: string | undefined) {
  if (!url) return url;
  return url.startsWith('http') ? url : `https://${url}`;
}
